(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Bilder-Karussell ---------- */
  if (!customElements.get('bodega-carousel')) {
    class BodegaCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bodega-carousel__track');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        if (this.slides.length < 2) return;

        var prev = this.querySelector('[data-prev]');
        var next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index() - 1));
        if (next) next.addEventListener('click', () => this.go(this.index() + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.go(Number(dot.dataset.dot)));
        });

        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.update());
          },
          { passive: true }
        );

        this.track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index() - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.go(this.index() + 1);
          }
        });

        if (this.dataset.autoplay === 'true' && !reducedMotion) this.setupAutoplay();
      }

      disconnectedCallback() {
        this.stop();
      }

      index() {
        var width = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / width);
      }

      go(target) {
        var count = this.slides.length;
        var i = ((target % count) + count) % count;
        this.track.scrollTo({
          left: i * this.track.clientWidth,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      }

      update() {
        var current = this.index();
        this.dots.forEach((dot, i) => {
          if (i === current) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      setupAutoplay() {
        this.speed = Number(this.dataset.speed) || 5000;
        this.start();
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.track.addEventListener('touchstart', () => this.stop(), { passive: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        });
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.go(this.index() + 1), this.speed);
      }

      stop() {
        if (this.timer) clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('bodega-carousel', BodegaCarousel);
  }

  /* ---------- Erzähl mir mehr ---------- */
  if (!customElements.get('bodega-story')) {
    class BodegaStory extends HTMLElement {
      connectedCallback() {
        this.clip = this.querySelector('.bodega__clip');
        this.text = this.querySelector('.bodega__text');
        this.button = this.querySelector('.bodega__toggle');
        if (!this.clip || !this.text || !this.button) return;

        this.isOpen = false;
        this.card = this.closest('.bodega__card');
        this.header = this.card && this.card.querySelector('.bodega__header');
        this.media = this.card && this.card.querySelector('.bodega__media');

        this.button.addEventListener('click', () => this.toggle());

        this.scheduleMeasure = () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.measure());
        };

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.scheduleMeasure);
          this.observer.observe(this.text);
          if (this.media) this.observer.observe(this.media);
        } else {
          window.addEventListener('resize', this.scheduleMeasure);
        }
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.scheduleMeasure);
        this.measure();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.scheduleMeasure);
      }

      // Liegen Text und Bilder nebeneinander (Desktop)?
      sideBySide() {
        if (!this.media || !this.card) return false;
        return getComputedStyle(this.card).gridTemplateColumns.trim().split(/\s+/).length > 1;
      }

      // Höhe bis zum Ende des ersten Absatzes (inkl. evtl. Überschrift davor)
      firstParagraphHeight() {
        var p = this.text.querySelector('p');
        if (!p) return 0;
        return p.getBoundingClientRect().bottom - this.text.getBoundingClientRect().top;
      }

      measure() {
        if (this.isOpen) return;

        var natural = this.text.offsetHeight;
        var first = this.firstParagraphHeight();
        var target = first;
        var fade = false;

        if (this.dataset.mode === 'fit' && this.sideBySide()) {
          // Button kurz einblenden, um seine Höhe zu kennen
          var wasHidden = this.button.hidden;
          this.button.hidden = false;
          var buttonSpace = this.button.offsetHeight + parseFloat(getComputedStyle(this.button).marginTop || 0);
          this.button.hidden = wasHidden;

          // Blogkarten unter dem Text sollen auch noch neben die Bilder passen
          var blog = this.card.querySelector('.bodega__blog');
          var blogSpace = blog ? blog.offsetHeight + parseFloat(getComputedStyle(blog).marginTop || 0) : 0;

          var startOffset = this.clip.getBoundingClientRect().top - this.header.getBoundingClientRect().top;
          var available = this.media.offsetHeight - startOffset - buttonSpace - blogSpace;
          // Nur verlängern, wenn danach noch mind. 3 Zeilen Platz sind – sonst sauber nach dem 1. Absatz schneiden
          var p = this.text.querySelector('p');
          var lineHeight = p ? parseFloat(getComputedStyle(p).lineHeight) || 28 : 28;
          if (available - first >= lineHeight * 3) {
            target = available;
            fade = true;
          }
        }

        // Alles passt (oder kein Absatz gefunden) -> ganzen Text zeigen, kein Button
        if (!target || natural <= target + 32) {
          this.clip.style.maxHeight = '';
          this.classList.remove('is-clamped', 'has-fade');
          this.button.hidden = true;
          return;
        }

        this.clip.style.maxHeight = Math.floor(target) + 'px';
        this.classList.add('is-clamped');
        this.classList.toggle('has-fade', fade);
        this.button.hidden = false;
      }

      setLabels() {
        this.button.setAttribute('aria-expanded', String(this.isOpen));
        this.button.querySelector('[data-more]').hidden = this.isOpen;
        this.button.querySelector('[data-less]').hidden = !this.isOpen;
      }

      toggle() {
        clearTimeout(this.openTimer);

        if (!this.isOpen) {
          this.isOpen = true;
          this.setLabels();
          this.classList.add('is-open');
          this.clip.style.maxHeight = this.text.offsetHeight + 'px';
          this.openTimer = setTimeout(() => {
            if (this.isOpen) this.clip.style.maxHeight = 'none';
          }, reducedMotion ? 0 : 450);
          return;
        }

        // Zuklappen: von aktueller Höhe zurück auf die Vorschau-Höhe animieren
        this.clip.style.maxHeight = this.text.offsetHeight + 'px';
        void this.clip.offsetHeight;
        this.isOpen = false;
        this.setLabels();
        this.classList.remove('is-open');
        this.measure();

        // Zurück zum Textanfang, falls der schon aus dem Bild gescrollt ist
        var top = this.getBoundingClientRect().top;
        if (top < 0) {
          window.scrollTo({
            top: window.scrollY + top - 120,
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        }
      }
    }

    customElements.define('bodega-story', BodegaStory);
  }
})();
